var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRescheduleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.49,
    y: 0.82,
    width: 11.01,
    height: 10.78,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25.82h-1l-.1,0A.24.24,0,0,0,10,.9.22.22,0,0,0,10,1a.44.44,0,0,0,0,.1l.09,1.75A5.25,5.25,0,0,0,8.23,1.47,5.36,5.36,0,0,0,6,1,5.29,5.29,0,0,0,.66,6.21,5.28,5.28,0,0,0,6,11.43a5.37,5.37,0,0,0,3.57-1.35A.16.16,0,0,0,9.63,10a.29.29,0,0,0,0-.1.36.36,0,0,0,0-.1.24.24,0,0,0-.06-.08L8.85,9A.27.27,0,0,0,8.5,9a3.85,3.85,0,0,1-4.28.49A3.82,3.82,0,0,1,2.63,7.91a3.66,3.66,0,0,1-.39-2.18,3.6,3.6,0,0,1,.95-2A3.76,3.76,0,0,1,5.13,2.6a3.85,3.85,0,0,1,2.25.16A3.8,3.8,0,0,1,9.14,4.14L7,4h-.1l-.09.06-.06.08a.36.36,0,0,0,0,.1v1a.27.27,0,0,0,.08.18.29.29,0,0,0,.18.07h4.31a.29.29,0,0,0,.18-.07.27.27,0,0,0,.08-.18V1.07a.25.25,0,0,0-.08-.18A.29.29,0,0,0,11.25.82Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRescheduleIcon);
export default __webpack_public_path__ + "static/media/reschedule_icon.e4d74ebb471350376d082d0f2f1572b5.svg";
export { ForwardRef as ReactComponent };